import React from "react";

export const ES_BENEFITS = [
  {
    label: "Sending Emails from your brand name",
    checked: true,
  },
  {
    label: "Manage different sender IDs for different Email communications",
    checked: true,
  },
];

export const ES_UNLOCKING_KEY_DETAILS = [
  {
    id: 1,
    label: (
      <>
        If you send an email from a{" "}
        <strong>free email address (@gmail, @yahoo, or @orange)</strong>, your
        emails will most likely be delivered to your recipients&apos; spam
        folder.
      </>
    ),
  },
  {
    id: 2,
    label: (
      <>
        You&apos;ll need to <strong>get a custom domain</strong> (if you
        don&apos;t have one already) and link to Exly (custom domain linking
        will also be unlocked with this purchase).
      </>
    ),
  },
];

export const FEATURE_SECTIONS_STEPS = [
  {
    id: 1,
    label: "Create your Own Brand ✨",
    info: "Remove ‘powered by Exly’ branding from all your end-user pages. Also, customise your customer invoices.",
  },
  {
    id: 2,
    label: "Fully Customizable Footer 🪄",
    info: "Customize your home page and thank you page footers for your needs. Add or remove and manage your back links.",
  },
  {
    id: 3,
    label: "Connect your own domain name 🌐",
    info: "Connect your own domain, send personalised offering links to your customers and remove Exly branding from links.",
  },
  {
    id: 4,
    label: "Connect your own number on Whatsapp 📢",
    info: "Sending messages from your brand name and respond to unlimited customer initiated conversations.",
  },
];
